import type { ListMatch } from "@/utils/portfolioUtils";

/**
 * The lists a highlighted row matched, by name, each in its own colour:
 * "(Oil · Energy names)".
 *
 * The row takes the first list's colour, as a row always has. A second match
 * used to go unmentioned, and a colour alone doesn't say which list it stands
 * for once several are switched on — so every match is named.
 */
export default function MatchedListNames({
  matches,
  className,
  spaced = true,
}: {
  matches: Pick<ListMatch, "name" | "color">[] | undefined;
  className?: string;
  /** A space before the bracket, for names that follow text in the same run. */
  spaced?: boolean;
}) {
  if (!matches?.length) return null;
  return (
    <span className={className}>
      {spaced ? " (" : "("}
      {matches.map((match, i) => (
        <span key={`${i}-${match.name}`}>
          {i > 0 && <span className="text-gray-500"> · </span>}
          <span style={{ color: match.color }}>{match.name}</span>
        </span>
      ))}
      {")"}
    </span>
  );
}
